class MyGlobleSetting {
  constructor() {
    this.url = 'http://localhost:8000';
    this.api='/pos';
    this.file = '/admin/uploads/';
  }
}
export default (new MyGlobleSetting);